require('./index.css');

var _pageUrl = location.protocol + '//' + location.host + location.pathname;
var sixDay = false








// WEBPACK FOOTER //
// ./modules/game_body/index.js